import { z } from 'zod';

export function configureValidationRuntime(): void {
  // Zod otherwise probes `Function()` before falling back, which is correctly blocked by CSP.
  z.config({ jitless: true });
}
